<script>
/* eslint-disable */
import { mapGetters } from "vuex";
export default {
  name: "Dropdown",
  props: ["activity"],
  data() {
    return {
      n_activity: this.activity,
    };
  },
  computed: {
    ...mapGetters({
      currentPaginationPage: "commons/currentPaginationPage",
      currentDataList: "commons/currentDataList",
      fieldOptionsChunked: "commons/fieldOptionsChunked",
      locationsOptions: "commons/locationsOptions",
      reviewOptions: "commons/reviewOptions",
      roughCutOptions: "commons/roughCutOptions",
      finalCutOptions: "commons/finalCutOptions",
      audioOptions: "commons/audioOptions",
      timerOptions: "commons/timerOptions",
      currentActivity: "commons/currentActivity",
      coloursOptions: "commons/coloursOptions",
      post_production: "commons/post_production",
      userFieldOption: "commons/userFieldOption",
      colourGradeOptions: "commons/colourGradeOptions",
      seriesOptions: "commons/seriesOptions",
    }),
    roughCutOptionsRemapped() {
      var options = [{ value: null, text: "Select" }];
      this.roughCutOptions.map((option) => {
        if (option.value != null && option.value != "") {
          options.push(option);
        }
      });
      return options;
    },
    userFieldOptionRemapped() {
      var options = [{ value: null, text: "Select" }];
      this.userFieldOption.map((option) => {
        if (option.value != null && option.value != "") {
          options.push(option);
        }
      });
      return options;
    },

    reviewOptionsRemapped() {
      var options = [{ value: null, text: "Select" }];
      this.reviewOptions.map((option) => {
        if (option.value != null && option.value != "") {
          options.push(option);
        }
      });
      return options;
    },

    finalCutOptionsRemapped() {
      var options = [{ value: null, text: "Select" }];
      this.finalCutOptions.map((option) => {
        if (option.value != null && option.value != "") {
          options.push(option);
        }
      });
      return options;
    },
    colourGradeOptionsRemapped() {
      var options = [{ value: null, text: "Select" }];
      this.colourGradeOptions.map((option) => {
        if (option.value != null && option.value != "") {
          options.push(option);
        }
      });
      return options;
    },
    audioOptionsRemapped() {
      var options = [{ value: null, text: "Select" }];
      this.audioOptions.map((option) => {
        if (option.value != null && option.value != "") {
          options.push(option);
        }
      });
      return options;
    },
  },
  methods: {
    updateSeries(event) {
      this.n_activity.series = event;
      this.$store.commit("commons/setPreloader", true);
      this.$store.dispatch("commons/updateSeries", this.n_activity).then(
        (res) => {
          this.$store.commit("commons/setPreloader", false);
          this.$store.commit(`commons/setSavingForm`, "Saved");
        },
        (error) => {
          console.log(error);
        }
      );
    },
  },
};
</script>
<template>
  <b-form-group class="select">
    <b-form-select
      @change="updateSeries($event)"
      :value="n_activity.series"
      :options="seriesOptions"
    ></b-form-select>
  </b-form-group>
</template>